<template>
	<div>
		<Homepage />
	</div>
</template>

<script>
	import Homepage from '@/components/Home.vue'

	export default {
		name: 'Home',
		components: {
			Homepage
		}
	}
</script>